import React, { Component } from 'react';

import { CommitGraphElement } from 'src/utils/commit-graph-builder';

import * as styles from './commit-graph.styled';
import Slice from './slice';

type ChunkProps = {
  chunk: CommitGraphElement[];
  focusedHash: string;
  left: number;
  top: number;
  colWidth: number;
  onNodeClick: (id: string) => void;
  sliceHeight: number;
  hasPadding: boolean;
};

export default class Chunk extends Component<ChunkProps> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    hasPadding: false,
  };

  // @ts-ignore TODO: fix noImplicitAny error here
  shouldComponentUpdate({ chunk, focusedHash }) {
    return (
      chunk[0].id !== this.props.chunk[0].hash ||
      chunk.length !== this.props.chunk.length ||
      // Check if the focused node has changed, and if it has, is it a change that this chunk cares about
      // (either the old or new focused node is contained in this chunk), otherwise don't update.
      // This may look expensive but it's not. It takes a fraction of a millisecond for 50 item chunks.
      // Much faster than doing the render and compare, even if the child slices don't update.
      (focusedHash !== this.props.focusedHash &&
        chunk.some(
          // @ts-ignore TODO: fix noImplicitAny error here
          ({ id }) => id === this.props.focusedHash || id === focusedHash
        ))
    );
  }

  // @ts-ignore TODO: fix noImplicitAny error here
  renderSlice = (slice, index) => {
    const { focusedHash, colWidth, onNodeClick, sliceHeight, hasPadding } =
      this.props;

    return (
      <Slice
        colWidth={colWidth}
        isFocused={slice.hash === focusedHash}
        key={`slice-${slice.hash}`}
        onNodeClick={onNodeClick}
        slice={slice}
        sliceHeight={sliceHeight}
        top={index * sliceHeight}
        hasPadding={index === 0 && hasPadding}
      />
    );
  };

  render() {
    const { chunk, colWidth, left, top, sliceHeight } = this.props;
    const columnHeight = chunk.length * sliceHeight;
    const xOffset = -left;
    const yOffset = top - sliceHeight;

    return (
      <g transform={`translate(${left}, ${top})`}>
        <styles.Column
          x={xOffset}
          y={yOffset}
          width={colWidth * 2}
          height={columnHeight}
        />
        {chunk.map(this.renderSlice)}
      </g>
    );
  }
}
